import React from "react";
import { useGetNbaAllTimeGreatsLeadersQuery } from "../../store/api/nbaApi";
import {
  getNbaDisplayName,
  NBA_COMPARE_PRESETS,
} from "../../adapters/nbaPlayerAdapter";
import { CompareInspirationHost } from "../compare/CompareInspiration";
import { getNbaCompareInspirationSections } from "../compare/compareInspirationCatalog";

const NBA_INSPIRATION_SECTIONS = getNbaCompareInspirationSections();

const nbaDisplayName = (row, player) => getNbaDisplayName(row, player.name);

const NbaCompareInspiration = ({ selectedIds, onSelect, onSelectMatchup }) => (
  <CompareInspirationHost
    sections={NBA_INSPIRATION_SECTIONS}
    selectedIds={selectedIds}
    onSelect={onSelect}
    matchups={NBA_COMPARE_PRESETS}
    onSelectMatchup={onSelectMatchup}
    sport="nba"
    getName={nbaDisplayName}
    useLeadersQuery={useGetNbaAllTimeGreatsLeadersQuery}
  />
);

export default NbaCompareInspiration;
